import { ID, NewImage } from '@griply/types';

export type BuildImageFromUploadOptions = {
  id: ID;
  url: string;
};

export const buildImageFromUpload = ({
  id,
  url,
}: BuildImageFromUploadOptions): NewImage => ({
  id,
  url,
});
